import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=1537f168&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=1537f168&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537f168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1537f168')) {
      api.createRecord('1537f168', component.options)
    } else {
      api.reload('1537f168', component.options)
    }
    module.hot.accept("./Facebook.vue?vue&type=template&id=1537f168&scoped=true", function () {
      api.rerender('1537f168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/Facebook.vue"
export default component.exports